
import { Order } from "@/utils/peppol/order";
import { roundDecimalsAdvanced } from "@/utils/numbers";
import Vue from "vue";
import AppParty from "./OrderPreviewParty.vue";
import AppLine from "./OrderPreviewLine.vue";
import AppVatGroup from "./OrderPreviewVatGroup.vue";

export default Vue.extend({
	props: {
		order: {
			type: Object as ()=>Order,
			required: true
		}
	},
	computed: {
		bankAccountIban(): string {
			return this.order.BankAccount?.Iban || this.order.Supplier?.IBAN || "";
		},
		bankAccountBic(): string {
			return this.order.BankAccount?.Bic || this.order.Supplier?.BIC || "";
		},
		hasPaymentInfo(): boolean {
			return !!(this.order.PaymentReference || this.bankAccountIban || this.bankAccountBic);
		}
	},
	methods: {
		formatDate(date: Date): string {
			if (!date || isNaN(date.getTime())) return "-";
			return date.toLocaleDateString("nl-BE");
		},
		formatNumber(value: number): string {
			return roundDecimalsAdvanced(value, {
				decimals: 2,
				decimalSeperator: ",",
				thousandsSeperator: ".",
				thousandSeperatorInterval: 3
			});
		}
	},
	components: {
		AppParty,
		AppLine,
		AppVatGroup
	},
	i18nEx: {
		componentPrefix: "components.OrderPreview"
	}
});
